export const AUTH_CONFIG = {
  SESSION: {
    DURATION: 23.5 * 60 * 60 * 1000, // 23.5 hours in milliseconds
    //DURATION: 1 * 60 * 1000,
    WARNING_OFFSET: 30 * 1000, // 30 seconds before logout
  },
  MESSAGES: {
    WARNING: "You will need to relogin in next 30 seconds",
    TITLE: "Session Expiring",
  },
  BUTTONS: {
    ACCEPT: {
      show: true,
      title: "OK",
    },
    CANCEL: {
      show: false,
    },
  },
};
